import { FaShoppingCart, FaCloud, FaHospital, FaChartLine } from "react-icons/fa";

export default function Section5() {
  const industries = [
    {
      title: "Email Marketing for E-commerce Stores",
      icon: <FaShoppingCart className="w-12 h-12 md:w-16 md:h-16 text-[#DA2128]" />
    },
    {
      title: "Email Campaigns for SaaS Companies",
      icon: <FaCloud className="w-12 h-12 md:w-16 md:h-16 text-[#DA2128]" />
    },
    {
      title: "Email Automation for Healthcare Providers",
      icon: <FaHospital className="w-12 h-12 md:w-16 md:h-16 text-[#DA2128]" />
    },
    {
      title: "Email Strategies for Finance & Enterprises",
      icon: <FaChartLine className="w-12 h-12 md:w-16 md:h-16 text-[#DA2128]" />
    }
  ];

  return (
    <div className="Section5 py-[60px] md:py-[100px] bg-[#f9f9f9]">
      <div className="text-center mb-16 max-w-4xl mx-auto">

        <h2 className="text-[28px] md:text-[36px] font-bold text-[#151515] leading-[32px] md:leading-[41px]">
          Email Marketing for Every Industry
        </h2>
        <p className="mt-10 text-[#555] text-[16px] md:text-[18px] max-w-[600px] mx-auto">
          Tailored email marketing solutions for businesses across different industries to maximize engagement and conversions.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-12 md:gap-16 w-[90%] md:w-[85%] mx-auto">
        {industries.map((industry, index) => (
          <div
            key={index}
            className="flex flex-col items-center text-center transition transform hover:-translate-y-2 hover:scale-105 duration-300"
          >
            {/* Icon */}
            <div className="mb-4">{industry.icon}</div>

            {/* Title */}
            <h3 className="text-[18px] md:text-[20px] font-semibold text-[#151515]">
              {industry.title}
            </h3>
          </div>
        ))}
      </div>
    </div>
  );
}
